import { RouteRule } from '@components/router';

export const routes: RouteRule[] = [[() => import('./landing-page'), '/landing-page']];
